import { ERbacPermissions } from 'features/rbac/rbacPermissionsList';
import { ServerError } from 'layout/ServerError';
import { LeftNavRoutesEnumCommon } from 'models/enums/commonRoutes/commonRoutes';
import { AppRoute } from 'models/types/Settings/routeType';
import {
  LoginPage,
  StyleGuidePage,
  UnderMaintenancePage,
  Users,
  Roles,
  Privileges,
} from 'views';
import Commissions from 'views/Common/Settings/Commissions/Commissions';
import Rules from 'views/Common/Settings/Rules/Rules';

const commonRoutes: AppRoute[] = [
  {
    auth: false,
    path: '/login',
    exact: true,
    component: LoginPage,
  },
  {
    auth: true,
    path: LeftNavRoutesEnumCommon.SETTINGS_USERS,
    exact: true,
    component: Users,
    allowedPermissions: [
      ERbacPermissions.USER_DETAILS_VIEW_ALL,
      ERbacPermissions.USER_DETAILS_VIEW_OWN,
      ERbacPermissions.USER_DETAILS_VIEW_TEAM,
    ],
  },
  {
    auth: true,
    path: LeftNavRoutesEnumCommon.SETTINGS_COMMISSIONS,
    exact: true,
    component: Commissions,
    allowedPermissions: [ERbacPermissions.SETTINGS_COMMISSIONS_VIEW],
  },
  {
    auth: true,
    path: LeftNavRoutesEnumCommon.SETTINGS_DYNAMIC_PRICING,
    exact: true,
    component: Rules,
    allowedPermissions: [
      ERbacPermissions.DYNAMIC_PRICING_RULES_VIEW_ALL,
      ERbacPermissions.DYNAMIC_PRICING_RULES_VIEW_TEAM,
      ERbacPermissions.DYNAMIC_PRICING_RULES_VIEW_OWN,
    ],
  },
  {
    auth: true,
    path: LeftNavRoutesEnumCommon.SETTINGS_ROLES,
    exact: true,
    component: Roles,
  },
  {
    auth: true,
    path: LeftNavRoutesEnumCommon.SETTINGS_PRIVILEGES,
    exact: true,
    component: Privileges,
  },
  {
    path: '/server-error',
    exact: true,
    component: ServerError,
  },
  {
    auth: false,
    path: '/styleguide',
    exact: true,
    component: StyleGuidePage,
  },
  {
    auth: false,
    path: '/under-maintenance-page',
    exact: true,
    component: UnderMaintenancePage,
  },
];

export { commonRoutes };
